import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { Product } from '@/core/domain/extras/models/extras-data.model';
import { CdnService } from '@/common/services/cdn/cdn.service';

@Component({
    selector: 'fe-travel-upgrades',
    templateUrl: './travel-upgrades.component.html',
    styleUrls: ['./travel-upgrades.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TravelUpgradesComponent implements OnChanges {
    @Input() products: Product[] = [];
    @Input() currency?: string;
    @Output() activeProductsChange = new EventEmitter<Product[]>();

    isActive: boolean[] = [];
    isActiveDetails: boolean[] = [];

    cardMeta = [
        {
            id: 0,
            icon: 'images/driver.svg',
            tagline: 'fe_details_step3_travel_upgrades_additional_driver_tagline',
        },
        {
            id: 1,
            icon: 'images/baby-chair.svg',
            tagline: 'fe_details_step3_travel_upgrades_baby_seat_tagline',
        },
    ];

    getMeta(product: Product) {
        const meta =
            this.cardMeta.find((meta) => meta.id === product.id) ??
            this.cardMeta[0];
        return { ...meta, icon: CdnService.url(meta.icon) };
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['products'] && this.products) {
            this.initializeActiveProducts();
        }
    }

    private initializeActiveProducts(): void {
        this.isActive = this.products.map((p) => !!p.isFree);
        this.isActiveDetails = this.products.map(() => false);
        this.emitActiveProducts();
    }

    toggleActive(product: Product, index: number): void {
        this.isActive[index] = !this.isActive[index];
        this.emitActiveProducts();
    }

    toggleDetails(index: number): void {
        const open = !this.isActiveDetails[index];
        this.isActiveDetails = this.isActiveDetails.map(() => false);
        this.isActiveDetails[index] = open;
    }

    closeDetails(index: number): void {
        this.isActiveDetails[index] = false;
    }

    private emitActiveProducts(): void {
        const activeProducts = this.products.filter((_, i) => this.isActive[i]);
        this.activeProductsChange.emit(activeProducts);
    }
}
